<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("customers") }}</div>

    <customer-datatable ref="customer_datatable" />
  </section>
</template>

<script>
import CustomerDatatable from "./customer_datatable/Index.vue";

export default {
  name: "Customers",
  components: {
    CustomerDatatable,
  },
};
</script>
